const features = [
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1804993_1660322_2018-10-30_1038",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1804993_1660322_2018-10-30_1038/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1804993_1660322_2018-10-30_1038/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.5176390705491,
            45.91867361868
          ],
          [
            -84.57119742015104,
            45.927539931724255
          ],
          [
            -84.5086268482603,
            46.117183374670255
          ],
          [
            -84.51725283245102,
            45.9248234678553
          ],
          [
            -84.5176390705491,
            45.91867361868
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1804993_1660322_2018-10-30_1038",
    "properties": {
      "acquired": "2018-10-30T16:03:55.508347Z",
      "anomalous_pixels": 0.06,
      "black_fill": 0.93,
      "cloud_cover": 0.064,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-31T00:34:12Z",
      "rows": 8000,
      "satellite_id": "1038",
      "strip_id": "1804993",
      "sun_azimuth": 158.8,
      "sun_elevation": 27.6,
      "updated": "2018-10-31T06:10:17Z",
      "usable_data": 0.01,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660321_2018-10-29_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660321_2018-10-29_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660321_2018-10-29_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82834357864098,
            45.92040775995348
          ],
          [
            -84.839801975551,
            45.92067644852728
          ],
          [
            -84.9136163676306,
            46.146955930888105
          ],
          [
            -84.81817264205792,
            46.14526116792308
          ],
          [
            -84.82697028762554,
            45.92040775995348
          ],
          [
            -84.82834357864098,
            45.92040775995348
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802217_1660321_2018-10-29_104b",
    "properties": {
      "acquired": "2018-10-29T15:27:53.767356Z",
      "anomalous_pixels": 0,
      "black_fill": 0.84,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-30T03:03:31Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1802217",
      "sun_azimuth": 149,
      "sun_elevation": 25.1,
      "updated": "2018-10-30T05:30:57Z",
      "usable_data": 0.16,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660322_2018-10-29_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660322_2018-10-29_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660322_2018-10-29_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52592173198593,
            45.91425485962961
          ],
          [
            -84.83980455970114,
            45.92067388714483
          ],
          [
            -84.83109274482196,
            46.145496481555604
          ],
          [
            -84.59698954203466,
            46.14070925813475
          ],
          [
            -84.5246771870032,
            45.914344432563716
          ],
          [
            -84.52592173198593,
            45.91425485962961
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802217_1660322_2018-10-29_104b",
    "properties": {
      "acquired": "2018-10-29T15:27:53.285797Z",
      "anomalous_pixels": 0,
      "black_fill": 0.2,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-30T03:03:30Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1802217",
      "sun_azimuth": 149,
      "sun_elevation": 25.1,
      "updated": "2018-10-30T05:30:57Z",
      "usable_data": 0.8,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660123_2018-10-29_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660123_2018-10-29_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660123_2018-10-29_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.38930457685527,
            45.479063054995
          ],
          [
            -84.54959338756298,
            45.48273403076466
          ],
          [
            -84.53976577373378,
            45.70755988600643
          ],
          [
            -84.4587845191674,
            45.70570179699326
          ],
          [
            -84.38930457685527,
            45.479063054995
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802217_1660123_2018-10-29_104b",
    "properties": {
      "acquired": "2018-10-29T15:27:46.064779Z",
      "anomalous_pixels": 0,
      "black_fill": 0.65,
      "cloud_cover": 0.002,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-30T03:03:22Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1802217",
      "sun_azimuth": 149,
      "sun_elevation": 25.5,
      "updated": "2018-10-30T05:30:43Z",
      "usable_data": 0.35,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660122_2018-10-29_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660122_2018-10-29_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660122_2018-10-29_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.53700029411725,
            45.48245234616462
          ],
          [
            -84.70110857046164,
            45.48579214120777
          ],
          [
            -84.77307760273925,
            45.71225393207061
          ],
          [
            -84.52695810356688,
            45.707279327670065
          ],
          [
            -84.53700029411725,
            45.48245234616462
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802217_1660122_2018-10-29_104b",
    "properties": {
      "acquired": "2018-10-29T15:27:46.546075Z",
      "anomalous_pixels": 0,
      "black_fill": 0.4,
      "cloud_cover": 0.002,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-30T03:03:20Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1802217",
      "sun_azimuth": 149,
      "sun_elevation": 25.5,
      "updated": "2018-10-30T05:30:42Z",
      "usable_data": 0.6,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660222_2018-10-29_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660222_2018-10-29_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660222_2018-10-29_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52773158261253,
            45.69827842163993
          ],
          [
            -84.77020327752514,
            45.70322385604068
          ],
          [
            -84.8398548812142,
            45.92083775496101
          ],
          [
            -84.83955447380457,
            45.929644023421574
          ],
          [
            -84.52760283657983,
            45.92331559216164
          ],
          [
            -84.51859061429104,
            45.895097529466426
          ],
          [
            -84.52773158261253,
            45.69827842163993
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802217_1660222_2018-10-29_104b",
    "properties": {
      "acquired": "2018-10-29T15:27:49.915936Z",
      "anomalous_pixels": 0,
      "black_fill": 0.17,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-30T03:03:14Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1802217",
      "sun_azimuth": 149,
      "sun_elevation": 25.3,
      "updated": "2018-10-30T05:30:38Z",
      "usable_data": 0.83,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660223_2018-10-29_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660223_2018-10-29_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802217_1660223_2018-10-29_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.45653589315056,
            45.69662951194139
          ],
          [
            -84.54017789905934,
            45.69857782304301
          ],
          [
            -84.5302644545417,
            45.923374964717375
          ],
          [
            -84.52756078785505,
            45.92307643629765
          ],
          [
            -84.45653589315056,
            45.69662951194139
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802217_1660223_2018-10-29_104b",
    "properties": {
      "acquired": "2018-10-29T15:27:49.915936Z",
      "anomalous_pixels": 0,
      "black_fill": 0.87,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-30T03:03:13Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1802217",
      "sun_azimuth": 149,
      "sun_elevation": 25.3,
      "updated": "2018-10-30T16:57:43Z",
      "usable_data": 0.13,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660122_2018-10-29_1025",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660122_2018-10-29_1025/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660122_2018-10-29_1025/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82672178302964,
            45.48828933605133
          ],
          [
            -84.85646211658265,
            45.488921138885246
          ],
          [
            -84.84787904773619,
            45.71378218547889
          ],
          [
            -84.7513624385577,
            45.71183440421662
          ],
          [
            -84.81736623798702,
            45.512774030821916
          ],
          [
            -84.82672178302964,
            45.48828933605133
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802399_1660122_2018-10-29_1025",
    "properties": {
      "acquired": "2018-10-29T16:04:50.191014Z",
      "anomalous_pixels": 0,
      "black_fill": 0.81,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:35:48Z",
      "rows": 8000,
      "satellite_id": "1025",
      "strip_id": "1802399",
      "sun_azimuth": 158.2,
      "sun_elevation": 28.2,
      "updated": "2018-10-30T05:22:09Z",
      "usable_data": 0.19,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660121_2018-10-29_1025",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660121_2018-10-29_1025/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660121_2018-10-29_1025/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.84537815733586,
            45.48867873163698
          ],
          [
            -85.16295170465503,
            45.49427441431872
          ],
          [
            -85.08990978877164,
            45.718005424914004
          ],
          [
            -84.83507847472009,
            45.71354074781238
          ],
          [
            -84.84361862822234,
            45.48922027361329
          ],
          [
            -84.84537815733586,
            45.48867873163698
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802399_1660121_2018-10-29_1025",
    "properties": {
      "acquired": "2018-10-29T16:04:50.713991Z",
      "anomalous_pixels": 0,
      "black_fill": 0.15,
      "cloud_cover": 0.002,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660121",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:35:48Z",
      "rows": 8000,
      "satellite_id": "1025",
      "strip_id": "1802399",
      "sun_azimuth": 158.2,
      "sun_elevation": 28.2,
      "updated": "2018-10-30T05:22:09Z",
      "usable_data": 0.85,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660222_2018-10-29_1025",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660222_2018-10-29_1025/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660222_2018-10-29_1025/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75544039910922,
            45.70289417402295
          ],
          [
            -84.84822337333951,
            45.70478232653361
          ],
          [
            -84.8394686431161,
            45.929644023421574
          ],
          [
            -84.67832152552374,
            45.92636049354554
          ],
          [
            -84.7522217482918,
            45.70924770330899
          ],
          [
            -84.75544039910922,
            45.70289417402295
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802399_1660222_2018-10-29_1025",
    "properties": {
      "acquired": "2018-10-29T16:04:47.052626Z",
      "anomalous_pixels": 0,
      "black_fill": 0.63,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:35:45Z",
      "rows": 8000,
      "satellite_id": "1025",
      "strip_id": "1802399",
      "sun_azimuth": 158.3,
      "sun_elevation": 28.1,
      "updated": "2018-10-30T05:22:06Z",
      "usable_data": 0.37,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660221_2018-10-29_1025",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660221_2018-10-29_1025/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660221_2018-10-29_1025/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83638627638706,
            45.704542555913655
          ],
          [
            -85.09284837351942,
            45.70906788761608
          ],
          [
            -85.01830442058788,
            45.93277811190054
          ],
          [
            -84.82664449324633,
            45.92940521908145
          ],
          [
            -84.83531339278126,
            45.7054116877761
          ],
          [
            -84.83638627638706,
            45.704542555913655
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802399_1660221_2018-10-29_1025",
    "properties": {
      "acquired": "2018-10-29T16:04:47.052626Z",
      "anomalous_pixels": 0,
      "black_fill": 0.34,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:35:45Z",
      "rows": 8000,
      "satellite_id": "1025",
      "strip_id": "1802399",
      "sun_azimuth": 158.3,
      "sun_elevation": 28.1,
      "updated": "2018-10-30T05:22:06Z",
      "usable_data": 0.66,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660322_2018-10-29_1025",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660322_2018-10-29_1025/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660322_2018-10-29_1025/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.68161860086079,
            45.91741968227523
          ],
          [
            -84.8398903903896,
            45.92067388714483
          ],
          [
            -84.8311356601662,
            46.145496481555604
          ],
          [
            -84.60415640452145,
            46.1408579359327
          ],
          [
            -84.68161860086079,
            45.91741968227523
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802399_1660322_2018-10-29_1025",
    "properties": {
      "acquired": "2018-10-29T16:04:43.914237Z",
      "anomalous_pixels": 0,
      "black_fill": 0.44,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:35:43Z",
      "rows": 8000,
      "satellite_id": "1025",
      "strip_id": "1802399",
      "sun_azimuth": 158.4,
      "sun_elevation": 27.9,
      "updated": "2018-10-30T05:21:59Z",
      "usable_data": 0.56,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660321_2018-10-29_1025",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660321_2018-10-29_1025/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802399_1660321_2018-10-29_1025/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8281290019198,
            45.92040775995348
          ],
          [
            -85.02124805096526,
            45.92384090493217
          ],
          [
            -84.94537372236252,
            46.147491108352874
          ],
          [
            -84.81817264205792,
            46.14523143477376
          ],
          [
            -84.82697028762554,
            45.92052717725804
          ],
          [
            -84.8281290019198,
            45.92040775995348
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802399_1660321_2018-10-29_1025",
    "properties": {
      "acquired": "2018-10-29T16:04:43.914237Z",
      "anomalous_pixels": 0,
      "black_fill": 0.53,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:35:43Z",
      "rows": 8000,
      "satellite_id": "1025",
      "strip_id": "1802399",
      "sun_azimuth": 158.4,
      "sun_elevation": 27.9,
      "updated": "2018-10-30T05:21:59Z",
      "usable_data": 0.47,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660123_2018-10-29_1002",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660123_2018-10-29_1002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660123_2018-10-29_1002/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.42264979932376,
            45.479815323612804
          ],
          [
            -84.54959338756298,
            45.48276411974169
          ],
          [
            -84.53972285838954,
            45.70755988600643
          ],
          [
            -84.34578841780369,
            45.70309437439959
          ],
          [
            -84.42097610089871,
            45.48026667996253
          ],
          [
            -84.42264979932376,
            45.479815323612804
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802397_1660123_2018-10-29_1002",
    "properties": {
      "acquired": "2018-10-29T16:03:22.283367Z",
      "anomalous_pixels": 0,
      "black_fill": 0.53,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:33:06Z",
      "rows": 8000,
      "satellite_id": "1002",
      "strip_id": "1802397",
      "sun_azimuth": 158.2,
      "sun_elevation": 28.3,
      "updated": "2018-10-30T08:39:26Z",
      "usable_data": 0.47,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660122_2018-10-29_1002",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660122_2018-10-29_1002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660122_2018-10-29_1002/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.5373436168711,
            45.48245234616462
          ],
          [
            -84.76058923756766,
            45.48699562242226
          ],
          [
            -84.68630277670151,
            45.71048590049967
          ],
          [
            -84.52695810356688,
            45.707279327670065
          ],
          [
            -84.5373436168711,
            45.48245234616462
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802397_1660122_2018-10-29_1002",
    "properties": {
      "acquired": "2018-10-29T16:03:22.283367Z",
      "anomalous_pixels": 0,
      "black_fill": 0.44,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:33:06Z",
      "rows": 8000,
      "satellite_id": "1002",
      "strip_id": "1802397",
      "sun_azimuth": 158.2,
      "sun_elevation": 28.3,
      "updated": "2018-10-30T08:39:27Z",
      "usable_data": 0.56,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660222_2018-10-29_1002",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660222_2018-10-29_1002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660222_2018-10-29_1002/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52777449795676,
            45.69827842163993
          ],
          [
            -84.68935076899145,
            45.70154545461476
          ],
          [
            -84.61454932399451,
            45.92507687902524
          ],
          [
            -84.51738898465253,
            45.92307676929879
          ],
          [
            -84.52777449795676,
            45.69827842163993
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802397_1660222_2018-10-29_1002",
    "properties": {
      "acquired": "2018-10-29T16:03:19.144716Z",
      "anomalous_pixels": 0,
      "black_fill": 0.62,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:33:04Z",
      "rows": 8000,
      "satellite_id": "1002",
      "strip_id": "1802397",
      "sun_azimuth": 158.3,
      "sun_elevation": 28.1,
      "updated": "2018-10-30T05:10:52Z",
      "usable_data": 0.38,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660223_2018-10-29_1002",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660223_2018-10-29_1002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660223_2018-10-29_1002/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.34924753256976,
            45.69417154571373
          ],
          [
            -84.54017789905934,
            45.69857782304301
          ],
          [
            -84.5302644545417,
            45.92334511194769
          ],
          [
            -84.27298696586891,
            45.917463803027566
          ],
          [
            -84.34924753256976,
            45.69417154571373
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802397_1660223_2018-10-29_1002",
    "properties": {
      "acquired": "2018-10-29T16:03:19.144716Z",
      "anomalous_pixels": 0.01,
      "black_fill": 0.35,
      "cloud_cover": 0.01,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:32:59Z",
      "rows": 8000,
      "satellite_id": "1002",
      "strip_id": "1802397",
      "sun_azimuth": 158.3,
      "sun_elevation": 28.1,
      "updated": "2018-10-30T05:10:52Z",
      "usable_data": 0.64,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660322_2018-10-29_1002",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660322_2018-10-29_1002/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1802397_1660322_2018-10-29_1002/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.51866903881067,
            45.914105571084825
          ],
          [
            -84.61814680674118,
            45.9161657175338
          ],
          [
            -84.54197207072883,
            46.139609029951835
          ],
          [
            -84.50768271068719,
            46.138895356672315
          ],
          [
            -84.51772490123756,
            45.9144041477728
          ],
          [
            -84.51866903881067,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1802397_1660322_2018-10-29_1002",
    "properties": {
      "acquired": "2018-10-29T16:03:16.006329Z",
      "anomalous_pixels": 0,
      "black_fill": 0.8,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-29T22:32:57Z",
      "rows": 8000,
      "satellite_id": "1002",
      "strip_id": "1802397",
      "sun_azimuth": 158.4,
      "sun_elevation": 27.9,
      "updated": "2018-10-30T05:10:40Z",
      "usable_data": 0.2,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660223_2018-10-24_1010",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660223_2018-10-24_1010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660223_2018-10-24_1010/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.36049135275861,
            45.80024524435796
          ],
          [
            -84.53442724293221,
            45.82818253493338
          ],
          [
            -84.5302644545417,
            45.923374964717375
          ],
          [
            -84.3204942519341,
            45.91853860654053
          ],
          [
            -84.36049135275861,
            45.80024524435796
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1789578_1660223_2018-10-24_1010",
    "properties": {
      "acquired": "2018-10-24T16:03:33.709247Z",
      "anomalous_pixels": 0.22,
      "black_fill": 0.73,
      "cloud_cover": 0.221,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-25T20:20:26Z",
      "rows": 8000,
      "satellite_id": "1010",
      "strip_id": "1789578",
      "sun_azimuth": 157.8,
      "sun_elevation": 29.6,
      "updated": "2018-10-26T05:00:04Z",
      "usable_data": 0.05,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660222_2018-10-24_1010",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660222_2018-10-24_1010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660222_2018-10-24_1010/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52180926510847,
            45.82614936322086
          ],
          [
            -84.68501631922398,
            45.85210088220649
          ],
          [
            -84.65991084284808,
            45.926002278527726
          ],
          [
            -84.51738898465253,
            45.92307676929879
          ],
          [
            -84.52180926510847,
            45.82614936322086
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1789578_1660222_2018-10-24_1010",
    "properties": {
      "acquired": "2018-10-24T16:03:33.709247Z",
      "anomalous_pixels": 0.15,
      "black_fill": 0.83,
      "cloud_cover": 0.148,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-25T20:20:26Z",
      "rows": 8000,
      "satellite_id": "1010",
      "strip_id": "1789578",
      "sun_azimuth": 157.8,
      "sun_elevation": 29.6,
      "updated": "2018-10-26T05:00:05Z",
      "usable_data": 0.03,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660322_2018-10-24_1010",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660322_2018-10-24_1010/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1789578_1660322_2018-10-24_1010/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.519098192253,
            45.914105571084825
          ],
          [
            -84.66277876474281,
            45.917031553359486
          ],
          [
            -84.58836355784398,
            46.140560579935325
          ],
          [
            -84.50768271068719,
            46.13883588348148
          ],
          [
            -84.51772490123756,
            45.91449372046595
          ],
          [
            -84.519098192253,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1789578_1660322_2018-10-24_1010",
    "properties": {
      "acquired": "2018-10-24T16:03:32.130354Z",
      "anomalous_pixels": 0.31,
      "black_fill": 0.67,
      "cloud_cover": 0.312,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-25T10:23:02Z",
      "rows": 8000,
      "satellite_id": "1010",
      "strip_id": "1789578",
      "sun_azimuth": 157.8,
      "sun_elevation": 29.5,
      "updated": "2018-10-26T05:00:04Z",
      "usable_data": 0.02,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660322_2018-10-24_1009",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660322_2018-10-24_1009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660322_2018-10-24_1009/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.72419062233925,
              45.91828549853513
            ],
            [
              -84.83984747504536,
              45.920644032921736
            ],
            [
              -84.83757296180104,
              45.98002214646741
            ],
            [
              -84.71037188149644,
              45.959082958342194
            ],
            [
              -84.72419062233925,
              45.91828549853513
            ]
          ]
        ],
        [
          [
            [
              -84.69011583901879,
              46.017555648285494
            ],
            [
              -84.83516970252406,
              46.041153828676954
            ],
            [
              -84.83431139563939,
              46.06265753283037
            ],
            [
              -84.68333521463009,
              46.03743003795875
            ],
            [
              -84.69011583901879,
              46.017555648285494
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1789345_1660322_2018-10-24_1009",
    "properties": {
      "acquired": "2018-10-24T16:05:12.949228Z",
      "anomalous_pixels": 0.1,
      "black_fill": 0.88,
      "cloud_cover": 0.097,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 4,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-25T06:14:10Z",
      "rows": 8000,
      "satellite_id": "1009",
      "strip_id": "1789345",
      "sun_azimuth": 157.8,
      "sun_elevation": 29.5,
      "updated": "2018-10-26T05:15:31Z",
      "usable_data": 0.02,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660222_2018-10-24_1009",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660222_2018-10-24_1009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660222_2018-10-24_1009/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.77981631463318,
              45.754061515112845
            ],
            [
              -84.84590594475095,
              45.76475040597402
            ],
            [
              -84.84509055321054,
              45.78585270535259
            ],
            [
              -84.77294985955602,
              45.77370115066909
            ],
            [
              -84.77981631463318,
              45.754061515112845
            ]
          ]
        ],
        [
          [
            [
              -84.7536808699957,
              45.831502107231444
            ],
            [
              -84.842773124622,
              45.84621202553
            ],
            [
              -84.83951155846033,
              45.929644023421574
            ],
            [
              -84.72097937769067,
              45.92722617028873
            ],
            [
              -84.7536808699957,
              45.831502107231444
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1789345_1660222_2018-10-24_1009",
    "properties": {
      "acquired": "2018-10-24T16:05:15.054506Z",
      "anomalous_pixels": 0.07,
      "black_fill": 0.86,
      "cloud_cover": 0.067,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 4,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-25T04:36:06Z",
      "rows": 8000,
      "satellite_id": "1009",
      "strip_id": "1789345",
      "sun_azimuth": 157.8,
      "sun_elevation": 29.6,
      "updated": "2018-10-26T05:15:30Z",
      "usable_data": 0.08,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660321_2018-10-24_1009",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660321_2018-10-24_1009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660321_2018-10-24_1009/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.82851524001791,
              45.92040775995348
            ],
            [
              -85.06802577617849,
              45.924646916872064
            ],
            [
              -85.03854293469088,
              46.01308771828311
            ],
            [
              -84.82473868972546,
              45.977907283887035
            ],
            [
              -84.82697028762554,
              45.92076601109607
            ],
            [
              -84.82851524001791,
              45.92040775995348
            ]
          ]
        ],
        [
          [
            [
              -84.82246417648115,
              46.03907109270451
            ],
            [
              -85.01721400860741,
              46.071235406164895
            ],
            [
              -85.01077670697258,
              46.0911500151427
            ],
            [
              -84.82156295425227,
              46.06057560760039
            ],
            [
              -84.82246417648115,
              46.03907109270451
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1789345_1660321_2018-10-24_1009",
    "properties": {
      "acquired": "2018-10-24T16:05:12.949228Z",
      "anomalous_pixels": 0.13,
      "black_fill": 0.72,
      "cloud_cover": 0.13,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 4,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-25T04:36:05Z",
      "rows": 8000,
      "satellite_id": "1009",
      "strip_id": "1789345",
      "sun_azimuth": 157.8,
      "sun_elevation": 29.5,
      "updated": "2018-10-26T05:15:30Z",
      "usable_data": 0.14,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660221_2018-10-24_1009",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660221_2018-10-24_1009/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1789345_1660221_2018-10-24_1009/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.8332534562581,
              45.76268463678025
            ],
            [
              -85.10529382334678,
              45.807305993802395
            ],
            [
              -85.09859902964655,
              45.82704649832436
            ],
            [
              -84.83235223402923,
              45.78372786210209
            ],
            [
              -84.8332534562581,
              45.76268463678025
            ]
          ]
        ],
        [
          [
            [
              -84.8300777207849,
              45.84411937952335
            ],
            [
              -85.0812612305767,
              45.885180468005395
            ],
            [
              -85.06503923045688,
              45.93361384124352
            ],
            [
              -84.82668740859056,
              45.92940521908145
            ],
            [
              -84.8300777207849,
              45.84411937952335
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1789345_1660221_2018-10-24_1009",
    "properties": {
      "acquired": "2018-10-24T16:05:15.054506Z",
      "anomalous_pixels": 0.17,
      "black_fill": 0.71,
      "cloud_cover": 0.167,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 4,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-25T04:36:05Z",
      "rows": 8000,
      "satellite_id": "1009",
      "strip_id": "1789345",
      "sun_azimuth": 157.8,
      "sun_elevation": 29.6,
      "updated": "2018-10-26T05:15:30Z",
      "usable_data": 0.13,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660121_2018-10-23_0f4d",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660121_2018-10-23_0f4d/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660121_2018-10-23_0f4d/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.84482025786086,
            45.48867873163698
          ],
          [
            -84.90545963926111,
            45.48979189560646
          ],
          [
            -84.97695660275215,
            45.71602782671565
          ],
          [
            -84.83503555937587,
            45.713510782331504
          ],
          [
            -84.84357571287809,
            45.49036351179844
          ],
          [
            -84.8437044589108,
            45.48867873163698
          ],
          [
            -84.84482025786086,
            45.48867873163698
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1787300_1660121_2018-10-23_0f4d",
    "properties": {
      "acquired": "2018-10-23T15:29:40.725477Z",
      "anomalous_pixels": 0.21,
      "black_fill": 0.7,
      "cloud_cover": 0.214,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660121",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T05:03:23Z",
      "rows": 8000,
      "satellite_id": "0f4d",
      "strip_id": "1787300",
      "sun_azimuth": 148.3,
      "sun_elevation": 27.4,
      "updated": "2018-10-30T19:49:02Z",
      "usable_data": 0.09,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660322_2018-10-23_0f51",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660322_2018-10-23_0f51/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660322_2018-10-23_0f51/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.519098192253,
            45.914105571084825
          ],
          [
            -84.6185330448393,
            45.9161657175338
          ],
          [
            -84.59952154734437,
            45.976055643121136
          ],
          [
            -84.57772055247433,
            46.03620857994574
          ],
          [
            -84.51270380596237,
            46.026614727104274
          ],
          [
            -84.51772490123756,
            45.91416528655093
          ],
          [
            -84.519098192253,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1786540_1660322_2018-10-23_0f51",
    "properties": {
      "acquired": "2018-10-23T16:03:24.966186Z",
      "anomalous_pixels": 0.07,
      "black_fill": 0.87,
      "cloud_cover": 0.072,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T04:27:11Z",
      "rows": 8000,
      "satellite_id": "0f51",
      "strip_id": "1786540",
      "sun_azimuth": 157.9,
      "sun_elevation": 30,
      "updated": "2018-10-24T05:18:01Z",
      "usable_data": 0.05,
      "view_angle": 1.9
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660222_2018-10-23_0f4c",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660222_2018-10-23_0f4c/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660222_2018-10-23_0f4c/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69484393305319,
            45.70166534210189
          ],
          [
            -84.84822337333951,
            45.70478232653361
          ],
          [
            -84.84418933098165,
            45.80895131187757
          ],
          [
            -84.6675068587772,
            45.7797173991383
          ],
          [
            -84.69368521875892,
            45.70172528574904
          ],
          [
            -84.69484393305319,
            45.70166534210189
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1786964_1660222_2018-10-23_0f4c",
    "properties": {
      "acquired": "2018-10-23T19:09:31.520256Z",
      "anomalous_pixels": 0.17,
      "black_fill": 0.8,
      "cloud_cover": 0.165,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 4,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T04:13:52Z",
      "rows": 8000,
      "satellite_id": "0f4c",
      "strip_id": "1786964",
      "sun_azimuth": 209.6,
      "sun_elevation": 28,
      "updated": "2018-10-24T04:13:52Z",
      "usable_data": 0.03,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660221_2018-10-23_0f4c",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660221_2018-10-23_0f4c/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660221_2018-10-23_0f4c/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83664376845246,
            45.704542555913655
          ],
          [
            -85.0361142884443,
            45.708078939122885
          ],
          [
            -84.9941859971293,
            45.83356530928989
          ],
          [
            -84.83140809645612,
            45.806857264640165
          ],
          [
            -84.83535630812548,
            45.704632466732946
          ],
          [
            -84.83664376845246,
            45.704542555913655
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1786964_1660221_2018-10-23_0f4c",
    "properties": {
      "acquired": "2018-10-23T19:09:32.056078Z",
      "anomalous_pixels": 0.26,
      "black_fill": 0.72,
      "cloud_cover": 0.262,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 4,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T04:13:52Z",
      "rows": 8000,
      "satellite_id": "0f4c",
      "strip_id": "1786964",
      "sun_azimuth": 209.6,
      "sun_elevation": 28,
      "updated": "2018-10-24T04:13:52Z",
      "usable_data": 0.01,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660122_2018-10-23_0f4c",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660122_2018-10-23_0f4c/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1786964_1660122_2018-10-23_0f4c/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76552450215435,
            45.487055795808054
          ],
          [
            -84.85646211658265,
            45.488921138885246
          ],
          [
            -84.84783613239195,
            45.71378218547889
          ],
          [
            -84.69080888784589,
            45.71060576881424
          ],
          [
            -84.76552450215435,
            45.487055795808054
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1786964_1660122_2018-10-23_0f4c",
    "properties": {
      "acquired": "2018-10-23T19:09:33.127461Z",
      "anomalous_pixels": 0.31,
      "black_fill": 0.63,
      "cloud_cover": 0.304,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 4,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T04:13:52Z",
      "rows": 8000,
      "satellite_id": "0f4c",
      "strip_id": "1786964",
      "sun_azimuth": 209.6,
      "sun_elevation": 28.1,
      "updated": "2018-10-24T04:13:52Z",
      "usable_data": 0.06,
      "view_angle": 0
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660222_2018-10-23_0f4d",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660222_2018-10-23_0f4d/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660222_2018-10-23_0f4d/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.66098372645389,
            45.70097598554016
          ],
          [
            -84.84822337333951,
            45.704812296694236
          ],
          [
            -84.84182898704888,
            45.869046548505516
          ],
          [
            -84.71977774805215,
            45.88792875303414
          ],
          [
            -84.67368666834665,
            45.74633549581983
          ],
          [
            -84.66342990107512,
            45.713443034300624
          ],
          [
            -84.66003958888076,
            45.70100595774133
          ],
          [
            -84.66098372645389,
            45.70097598554016
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1787300_1660222_2018-10-23_0f4d",
    "properties": {
      "acquired": "2018-10-23T15:29:42.641226Z",
      "anomalous_pixels": 0.22,
      "black_fill": 0.64,
      "cloud_cover": 0.221,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T03:19:34Z",
      "rows": 8000,
      "satellite_id": "0f4d",
      "strip_id": "1787300",
      "sun_azimuth": 148.3,
      "sun_elevation": 27.3,
      "updated": "2018-10-24T05:13:07Z",
      "usable_data": 0.14,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660221_2018-10-23_0f4d",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660221_2018-10-23_0f4d/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1787300_1660221_2018-10-23_0f4d/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83621461501015,
            45.704542555913655
          ],
          [
            -84.9733291398324,
            45.70697009727807
          ],
          [
            -85.01821858989942,
            45.84148852383914
          ],
          [
            -84.82891900649064,
            45.87101871561875
          ],
          [
            -84.83621461501015,
            45.704542555913655
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1787300_1660221_2018-10-23_0f4d",
    "properties": {
      "acquired": "2018-10-23T15:29:43.120163Z",
      "anomalous_pixels": 0.26,
      "black_fill": 0.67,
      "cloud_cover": 0.259,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T03:19:34Z",
      "rows": 8000,
      "satellite_id": "0f4d",
      "strip_id": "1787300",
      "sun_azimuth": 148.3,
      "sun_elevation": 27.3,
      "updated": "2018-10-24T05:13:07Z",
      "usable_data": 0.07,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660123_2018-10-23_0f51",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660123_2018-10-23_0f51/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660123_2018-10-23_0f51/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.41994613263714,
            45.479755142492984
          ],
          [
            -84.54959338756298,
            45.48276411974169
          ],
          [
            -84.53976577373378,
            45.70755988600643
          ],
          [
            -84.3444580421325,
            45.70306440331799
          ],
          [
            -84.41818660352361,
            45.48002595702597
          ],
          [
            -84.41994613263714,
            45.479755142492984
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1786540_1660123_2018-10-23_0f51",
    "properties": {
      "acquired": "2018-10-23T16:03:30.231872Z",
      "anomalous_pixels": 0.34,
      "black_fill": 0.52,
      "cloud_cover": 0.335,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T00:41:29Z",
      "rows": 8000,
      "satellite_id": "0f51",
      "strip_id": "1786540",
      "sun_azimuth": 157.7,
      "sun_elevation": 30.3,
      "updated": "2018-10-24T05:17:58Z",
      "usable_data": 0.14,
      "view_angle": 1.9
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660122_2018-10-23_0f51",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660122_2018-10-23_0f51/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660122_2018-10-23_0f51/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.53717195549419,
            45.48245234616462
          ],
          [
            -84.75685560261944,
            45.486905362223055
          ],
          [
            -84.68600236929186,
            45.71051586760241
          ],
          [
            -84.52695810356688,
            45.707279327670065
          ],
          [
            -84.53717195549419,
            45.48245234616462
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1786540_1660122_2018-10-23_0f51",
    "properties": {
      "acquired": "2018-10-23T16:03:30.231872Z",
      "anomalous_pixels": 0.36,
      "black_fill": 0.44,
      "cloud_cover": 0.357,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T00:41:29Z",
      "rows": 8000,
      "satellite_id": "0f51",
      "strip_id": "1786540",
      "sun_azimuth": 157.7,
      "sun_elevation": 30.3,
      "updated": "2018-10-24T05:17:58Z",
      "usable_data": 0.2,
      "view_angle": 1.9
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660222_2018-10-23_0f51",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660222_2018-10-23_0f51/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1786540_1660222_2018-10-23_0f51/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52777449795676,
            45.69827842163993
          ],
          [
            -84.68896453089336,
            45.70157542651064
          ],
          [
            -84.61575095363303,
            45.92507687902524
          ],
          [
            -84.51738898465253,
            45.92307676929879
          ],
          [
            -84.52777449795676,
            45.69827842163993
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1786540_1660222_2018-10-23_0f51",
    "properties": {
      "acquired": "2018-10-23T16:03:27.072513Z",
      "anomalous_pixels": 0.16,
      "black_fill": 0.62,
      "cloud_cover": 0.165,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-24T00:41:23Z",
      "rows": 8000,
      "satellite_id": "0f51",
      "strip_id": "1786540",
      "sun_azimuth": 157.8,
      "sun_elevation": 30.1,
      "updated": "2018-10-24T05:17:58Z",
      "usable_data": 0.22,
      "view_angle": 1.9
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660322_2018-10-22_0f21",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660322_2018-10-22_0f21/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660322_2018-10-22_0f21/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.5187119541549,
            45.914105571084825
          ],
          [
            -84.61578646280842,
            45.91610600422026
          ],
          [
            -84.68741217233216,
            46.14258256904843
          ],
          [
            -84.50768271068719,
            46.138895356672315
          ],
          [
            -84.5176390705491,
            45.916285143968125
          ],
          [
            -84.5187119541549,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1785448_1660322_2018-10-22_0f21",
    "properties": {
      "acquired": "2018-10-22T15:27:46.158875Z",
      "anomalous_pixels": 0,
      "black_fill": 0.59,
      "cloud_cover": 0.002,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T09:34:27Z",
      "rows": 8000,
      "satellite_id": "0f21",
      "strip_id": "1785448",
      "sun_azimuth": 148,
      "sun_elevation": 27.3,
      "updated": "2018-10-23T09:34:27Z",
      "usable_data": 0.4,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660123_2018-10-22_0f21",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660123_2018-10-22_0f21/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660123_2018-10-22_0f21/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.23017448044183,
            45.47542193293977
          ],
          [
            -84.4770235404661,
            45.48110920214132
          ],
          [
            -84.54092448802805,
            45.681960774597776
          ],
          [
            -84.53976577373378,
            45.70755988600643
          ],
          [
            -84.23734134292862,
            45.70060671994996
          ],
          [
            -84.2214197502184,
            45.65062039231011
          ],
          [
            -84.23017448044183,
            45.47542193293977
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1785448_1660123_2018-10-22_0f21",
    "properties": {
      "acquired": "2018-10-22T15:27:39.471058Z",
      "anomalous_pixels": 0,
      "black_fill": 0.16,
      "cloud_cover": 0.002,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T09:34:15Z",
      "rows": 8000,
      "satellite_id": "0f21",
      "strip_id": "1785448",
      "sun_azimuth": 148,
      "sun_elevation": 27.7,
      "updated": "2018-10-23T09:34:15Z",
      "usable_data": 0.83,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660223_2018-10-22_0f21",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660223_2018-10-22_0f21/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660223_2018-10-22_0f21/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.23449190209253,
            45.69153360811468
          ],
          [
            -84.54017789905934,
            45.69857782304301
          ],
          [
            -84.5302644545417,
            45.923374964717375
          ],
          [
            -84.30603178092782,
            45.918210196564786
          ],
          [
            -84.23449190209253,
            45.69153360811468
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1785448_1660223_2018-10-22_0f21",
    "properties": {
      "acquired": "2018-10-22T15:27:42.337341Z",
      "anomalous_pixels": 0,
      "black_fill": 0.23,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T09:34:06Z",
      "rows": 8000,
      "satellite_id": "0f21",
      "strip_id": "1785448",
      "sun_azimuth": 148,
      "sun_elevation": 27.5,
      "updated": "2018-10-23T09:34:06Z",
      "usable_data": 0.77,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660222_2018-10-22_0f21",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660222_2018-10-22_0f21/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1785448_1660222_2018-10-22_0f21/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.5275599212356,
            45.69827842163993
          ],
          [
            -84.54618518063243,
            45.69866807780054
          ],
          [
            -84.6186691970408,
            45.92516643449048
          ],
          [
            -84.51738898465253,
            45.92310662221286
          ],
          [
            -84.5275599212356,
            45.69827842163993
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1785448_1660222_2018-10-22_0f21",
    "properties": {
      "acquired": "2018-10-22T15:27:42.814967Z",
      "anomalous_pixels": 0,
      "black_fill": 0.82,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T09:34:06Z",
      "rows": 8000,
      "satellite_id": "0f21",
      "strip_id": "1785448",
      "sun_azimuth": 148,
      "sun_elevation": 27.5,
      "updated": "2018-10-23T09:34:06Z",
      "usable_data": 0.18,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660122_2018-10-22_1004",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660122_2018-10-22_1004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660122_2018-10-22_1004/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83551942859728,
            45.48846985186988
          ],
          [
            -84.85646211658265,
            45.488921138885246
          ],
          [
            -84.84787904773619,
            45.71375222012747
          ],
          [
            -84.7606750682561,
            45.71201420225395
          ],
          [
            -84.83393156086068,
            45.488620281276745
          ],
          [
            -84.83551942859728,
            45.48846985186988
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784112_1660122_2018-10-22_1004",
    "properties": {
      "acquired": "2018-10-22T16:05:29.842969Z",
      "anomalous_pixels": 0,
      "black_fill": 0.84,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:47:45Z",
      "rows": 8000,
      "satellite_id": "1004",
      "strip_id": "1784112",
      "sun_azimuth": 157.4,
      "sun_elevation": 30.5,
      "updated": "2018-10-23T05:03:46Z",
      "usable_data": 0.16,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660121_2018-10-22_1004",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660121_2018-10-22_1004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660121_2018-10-22_1004/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.84550690336857,
            45.48867873163698
          ],
          [
            -85.1634237734416,
            45.49427441431872
          ],
          [
            -85.16213631311463,
            45.53390961498586
          ],
          [
            -85.10312771479518,
            45.718245129030684
          ],
          [
            -84.83503555937587,
            45.71354074781238
          ],
          [
            -84.84361862822234,
            45.489160102539714
          ],
          [
            -84.84550690336857,
            45.48867873163698
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784112_1660121_2018-10-22_1004",
    "properties": {
      "acquired": "2018-10-22T16:05:29.842969Z",
      "anomalous_pixels": 0.01,
      "black_fill": 0.11,
      "cloud_cover": 0.01,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660121",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:47:45Z",
      "rows": 8000,
      "satellite_id": "1004",
      "strip_id": "1784112",
      "sun_azimuth": 157.4,
      "sun_elevation": 30.5,
      "updated": "2018-10-23T05:03:46Z",
      "usable_data": 0.88,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660222_2018-10-22_1004",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660222_2018-10-22_1004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660222_2018-10-22_1004/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76449553674225,
            45.703074000819086
          ],
          [
            -84.84822337333951,
            45.70478232653361
          ],
          [
            -84.83951155846033,
            45.929644023421574
          ],
          [
            -84.68780581659908,
            45.92656945123769
          ],
          [
            -84.76449553674225,
            45.703074000819086
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784112_1660222_2018-10-22_1004",
    "properties": {
      "acquired": "2018-10-22T16:05:26.674697Z",
      "anomalous_pixels": 0,
      "black_fill": 0.65,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:47:43Z",
      "rows": 8000,
      "satellite_id": "1004",
      "strip_id": "1784112",
      "sun_azimuth": 157.5,
      "sun_elevation": 30.3,
      "updated": "2018-10-23T05:03:45Z",
      "usable_data": 0.35,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660221_2018-10-22_1004",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660221_2018-10-22_1004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660221_2018-10-22_1004/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8361716996659,
            45.704542555913655
          ],
          [
            -85.1061092148872,
            45.70930763007031
          ],
          [
            -85.03177983867683,
            45.933016892997905
          ],
          [
            -84.82664449324633,
            45.92937536955681
          ],
          [
            -84.8361716996659,
            45.704542555913655
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784112_1660221_2018-10-22_1004",
    "properties": {
      "acquired": "2018-10-22T16:05:26.674697Z",
      "anomalous_pixels": 0,
      "black_fill": 0.3,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:47:43Z",
      "rows": 8000,
      "satellite_id": "1004",
      "strip_id": "1784112",
      "sun_azimuth": 157.5,
      "sun_elevation": 30.3,
      "updated": "2018-10-23T05:03:45Z",
      "usable_data": 0.7,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660322_2018-10-22_1004",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660322_2018-10-22_1004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660322_2018-10-22_1004/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.69101706124766,
            45.917598817782235
          ],
          [
            -84.8398903903896,
            45.920644032921736
          ],
          [
            -84.83109274482196,
            46.145496481555604
          ],
          [
            -84.61479940989106,
            46.14106608417532
          ],
          [
            -84.69101706124766,
            45.917598817782235
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784112_1660322_2018-10-22_1004",
    "properties": {
      "acquired": "2018-10-22T16:05:23.506949Z",
      "anomalous_pixels": 0,
      "black_fill": 0.47,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:47:42Z",
      "rows": 8000,
      "satellite_id": "1004",
      "strip_id": "1784112",
      "sun_azimuth": 157.6,
      "sun_elevation": 30.2,
      "updated": "2018-10-23T05:03:44Z",
      "usable_data": 0.53,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660321_2018-10-22_1004",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660321_2018-10-22_1004/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784112_1660321_2018-10-22_1004/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82860107070636,
            45.92040775995348
          ],
          [
            -85.03480929974268,
            45.924079724505575
          ],
          [
            -84.95975036268034,
            46.147758695134065
          ],
          [
            -84.81817264205792,
            46.145201701608386
          ],
          [
            -84.82697028762554,
            45.92052717725804
          ],
          [
            -84.82860107070636,
            45.92040775995348
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784112_1660321_2018-10-22_1004",
    "properties": {
      "acquired": "2018-10-22T16:05:23.506949Z",
      "anomalous_pixels": 0,
      "black_fill": 0.48,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:47:42Z",
      "rows": 8000,
      "satellite_id": "1004",
      "strip_id": "1784112",
      "sun_azimuth": 157.6,
      "sun_elevation": 30.2,
      "updated": "2018-10-23T05:03:45Z",
      "usable_data": 0.51,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660123_2018-10-22_1013",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660123_2018-10-22_1013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660123_2018-10-22_1013/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.49088519665317,
            45.48138001016601
          ],
          [
            -84.54959338756298,
            45.48276411974169
          ],
          [
            -84.539808689078,
            45.707440011159704
          ],
          [
            -84.41419547651,
            45.70468281873209
          ],
          [
            -84.49088519665317,
            45.48138001016601
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784111_1660123_2018-10-22_1013",
    "properties": {
      "acquired": "2018-10-22T16:04:08.162445Z",
      "anomalous_pixels": 0,
      "black_fill": 0.73,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:34:49Z",
      "rows": 8000,
      "satellite_id": "1013",
      "strip_id": "1784111",
      "sun_azimuth": 157.4,
      "sun_elevation": 30.5,
      "updated": "2018-10-23T04:49:49Z",
      "usable_data": 0.27,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660122_2018-10-22_1013",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660122_2018-10-22_1013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660122_2018-10-22_1013/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.53695737877302,
            45.48245234616462
          ],
          [
            -84.82998334919131,
            45.48837959403292
          ],
          [
            -84.75488149678475,
            45.71189433695999
          ],
          [
            -84.52695810356688,
            45.707279327670065
          ],
          [
            -84.53695737877302,
            45.48245234616462
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784111_1660122_2018-10-22_1013",
    "properties": {
      "acquired": "2018-10-22T16:04:08.690403Z",
      "anomalous_pixels": 0,
      "black_fill": 0.23,
      "cloud_cover": 0.002,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:34:49Z",
      "rows": 8000,
      "satellite_id": "1013",
      "strip_id": "1784111",
      "sun_azimuth": 157.4,
      "sun_elevation": 30.6,
      "updated": "2018-10-23T04:49:49Z",
      "usable_data": 0.77,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660223_2018-10-22_1013",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660223_2018-10-22_1013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660223_2018-10-22_1013/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.41864164419341,
            45.695760243550104
          ],
          [
            -84.54017789905934,
            45.69857782304301
          ],
          [
            -84.5302644545417,
            45.923374964717375
          ],
          [
            -84.34225233145989,
            45.91904614540711
          ],
          [
            -84.40293462820439,
            45.73705054571974
          ],
          [
            -84.41709669180105,
            45.695850168493074
          ],
          [
            -84.41864164419341,
            45.695760243550104
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784111_1660223_2018-10-22_1013",
    "properties": {
      "acquired": "2018-10-22T16:04:04.467263Z",
      "anomalous_pixels": 0,
      "black_fill": 0.55,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:34:47Z",
      "rows": 8000,
      "satellite_id": "1013",
      "strip_id": "1784111",
      "sun_azimuth": 157.6,
      "sun_elevation": 30.3,
      "updated": "2018-10-23T04:49:48Z",
      "usable_data": 0.45,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660222_2018-10-22_1013",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660222_2018-10-22_1013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660222_2018-10-22_1013/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52738825985867,
            45.69827842163993
          ],
          [
            -84.75775782769776,
            45.7029541163526
          ],
          [
            -84.68394343561816,
            45.92647989803744
          ],
          [
            -84.51738898465253,
            45.92307676929879
          ],
          [
            -84.52738825985867,
            45.69827842163993
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784111_1660222_2018-10-22_1013",
    "properties": {
      "acquired": "2018-10-22T16:04:05.522917Z",
      "anomalous_pixels": 0,
      "black_fill": 0.42,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:34:47Z",
      "rows": 8000,
      "satellite_id": "1013",
      "strip_id": "1784111",
      "sun_azimuth": 157.5,
      "sun_elevation": 30.4,
      "updated": "2018-10-23T04:49:48Z",
      "usable_data": 0.58,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660322_2018-10-22_1013",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660322_2018-10-22_1013/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1784111_1660322_2018-10-22_1013/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.5189694462203,
            45.914105571084825
          ],
          [
            -84.68689718820137,
            45.917539106010814
          ],
          [
            -84.61342611887564,
            46.14106608417532
          ],
          [
            -84.50768271068719,
            46.138895356672315
          ],
          [
            -84.51768198589333,
            45.91571786611598
          ],
          [
            -84.5177678165818,
            45.91413542882591
          ],
          [
            -84.5189694462203,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1784111_1660322_2018-10-22_1013",
    "properties": {
      "acquired": "2018-10-22T16:04:01.299515Z",
      "anomalous_pixels": 0,
      "black_fill": 0.6,
      "cloud_cover": 0.002,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-23T00:34:45Z",
      "rows": 8000,
      "satellite_id": "1013",
      "strip_id": "1784111",
      "sun_azimuth": 157.7,
      "sun_elevation": 30.2,
      "updated": "2018-10-23T04:49:47Z",
      "usable_data": 0.4,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1779629_1660321_2018-10-20_0f3d",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1779629_1660321_2018-10-20_0f3d/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1779629_1660321_2018-10-20_0f3d/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8327638590969,
            45.92049732295599
          ],
          [
            -85.14368552806008,
            45.925990244082
          ],
          [
            -85.14870662333526,
            45.94165999134608
          ],
          [
            -85.14647502543517,
            46.00799092237616
          ],
          [
            -84.87370509749454,
            46.05030094900592
          ],
          [
            -84.83147639876994,
            45.92061674006777
          ],
          [
            -84.8327638590969,
            45.92049732295599
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1779629_1660321_2018-10-20_0f3d",
    "properties": {
      "acquired": "2018-10-20T15:30:42.92466Z",
      "anomalous_pixels": 0.2,
      "black_fill": 0.59,
      "cloud_cover": 0.201,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.5,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-21T06:20:38Z",
      "rows": 8000,
      "satellite_id": "0f3d",
      "strip_id": "1779629",
      "sun_azimuth": 147.9,
      "sun_elevation": 28.1,
      "updated": "2018-10-21T06:20:38Z",
      "usable_data": 0.21,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1779629_1660221_2018-10-20_0f3d",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1779629_1660221_2018-10-20_0f3d/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1779629_1660221_2018-10-20_0f3d/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.11065824137583,
            45.826448404036896
          ],
          [
            -85.14657838449828,
            45.935046490817264
          ],
          [
            -84.83424050917544,
            45.9292559712976
          ],
          [
            -84.82750280013097,
            45.90805870860289
          ],
          [
            -84.82891900649064,
            45.871287643266555
          ],
          [
            -85.11065824137583,
            45.826448404036896
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1779629_1660221_2018-10-20_0f3d",
    "properties": {
      "acquired": "2018-10-20T15:30:42.447034Z",
      "anomalous_pixels": 0.19,
      "black_fill": 0.67,
      "cloud_cover": 0.192,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.5,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-21T06:20:38Z",
      "rows": 8000,
      "satellite_id": "0f3d",
      "strip_id": "1779629",
      "sun_azimuth": 147.9,
      "sun_elevation": 28.1,
      "updated": "2018-10-21T06:20:38Z",
      "usable_data": 0.14,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1778928_1660321_2018-10-20_0f35",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1778928_1660321_2018-10-20_0f35/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1778928_1660321_2018-10-20_0f35/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82821483260827,
            45.92040775995348
          ],
          [
            -84.87812537795045,
            45.92130338347272
          ],
          [
            -85.09836692455073,
            45.95690762672835
          ],
          [
            -85.032835193908,
            46.14903714735667
          ],
          [
            -84.81817264205792,
            46.14523143477376
          ],
          [
            -84.82697028762554,
            45.920557031544014
          ],
          [
            -84.82821483260827,
            45.92040775995348
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1778928_1660321_2018-10-20_0f35",
    "properties": {
      "acquired": "2018-10-20T16:05:13.93055Z",
      "anomalous_pixels": 0.35,
      "black_fill": 0.32,
      "cloud_cover": 0.347,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-21T00:26:17Z",
      "rows": 8000,
      "satellite_id": "0f35",
      "strip_id": "1778928",
      "sun_azimuth": 157.2,
      "sun_elevation": 30.8,
      "updated": "2018-10-21T05:39:48Z",
      "usable_data": 0.34,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1778928_1660322_2018-10-20_0f35",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1778928_1660322_2018-10-20_0f35/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1778928_1660322_2018-10-20_0f35/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76702013588312,
            45.91915130128534
          ],
          [
            -84.8398903903896,
            45.92070374135187
          ],
          [
            -84.83109274482196,
            46.145496481555604
          ],
          [
            -84.68857088662644,
            46.14258256904843
          ],
          [
            -84.76702013588312,
            45.91915130128534
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1778928_1660322_2018-10-20_0f35",
    "properties": {
      "acquired": "2018-10-20T16:05:13.93055Z",
      "anomalous_pixels": 0.1,
      "black_fill": 0.69,
      "cloud_cover": 0.103,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-21T00:26:16Z",
      "rows": 8000,
      "satellite_id": "0f35",
      "strip_id": "1778928",
      "sun_azimuth": 157.2,
      "sun_elevation": 30.8,
      "updated": "2018-10-21T05:39:48Z",
      "usable_data": 0.21,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660322_2018-10-18_0f4a",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660322_2018-10-18_0f4a/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660322_2018-10-18_0f4a/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.51866903881067,
            45.914105571084825
          ],
          [
            -84.5679787693336,
            45.915180439643635
          ],
          [
            -84.640462785742,
            46.14163105401009
          ],
          [
            -84.50768271068719,
            46.138895356672315
          ],
          [
            -84.51772490123756,
            45.91443400535324
          ],
          [
            -84.51866903881067,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774943_1660322_2018-10-18_0f4a",
    "properties": {
      "acquired": "2018-10-18T15:28:37.717287Z",
      "anomalous_pixels": 0,
      "black_fill": 0.73,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.5,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T03:23:26Z",
      "rows": 8000,
      "satellite_id": "0f4a",
      "strip_id": "1774943",
      "sun_azimuth": 147.5,
      "sun_elevation": 28.7,
      "updated": "2018-10-19T05:29:29Z",
      "usable_data": 0.27,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660222_2018-10-18_0f4a",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660222_2018-10-18_0f4a/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660222_2018-10-18_0f4a/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52391211697585,
            45.77738281262274
          ],
          [
            -84.55309455105383,
            45.86797078673235
          ],
          [
            -84.57086150356601,
            45.9241813164213
          ],
          [
            -84.51738898465253,
            45.92310662221286
          ],
          [
            -84.52391211697585,
            45.77738281262274
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774943_1660222_2018-10-18_0f4a",
    "properties": {
      "acquired": "2018-10-18T15:28:34.868568Z",
      "anomalous_pixels": 0,
      "black_fill": 0.95,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.5,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T03:23:11Z",
      "rows": 8000,
      "satellite_id": "0f4a",
      "strip_id": "1774943",
      "sun_azimuth": 147.5,
      "sun_elevation": 28.8,
      "updated": "2018-10-19T05:29:15Z",
      "usable_data": 0.05,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660223_2018-10-18_0f4a",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660223_2018-10-18_0f4a/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774943_1660223_2018-10-18_0f4a/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.21990068505353,
            45.691203857166094
          ],
          [
            -84.49816377705591,
            45.69764863698511
          ],
          [
            -84.53502805775148,
            45.81224145108515
          ],
          [
            -84.53022153919744,
            45.923374964717375
          ],
          [
            -84.25964029381268,
            45.91713538669054
          ],
          [
            -84.21517999718799,
            45.77621514882842
          ],
          [
            -84.21990068505353,
            45.691203857166094
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774943_1660223_2018-10-18_0f4a",
    "properties": {
      "acquired": "2018-10-18T15:28:33.91882Z",
      "anomalous_pixels": 0,
      "black_fill": 0.14,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.5,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T03:23:05Z",
      "rows": 8000,
      "satellite_id": "0f4a",
      "strip_id": "1774943",
      "sun_azimuth": 147.5,
      "sun_elevation": 28.9,
      "updated": "2018-10-19T05:29:11Z",
      "usable_data": 0.86,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660122_2018-10-18_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660122_2018-10-18_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660122_2018-10-18_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.57995855369379,
            45.48332492433696
          ],
          [
            -84.85646211658265,
            45.488921138885246
          ],
          [
            -84.84779321704772,
            45.71378218547889
          ],
          [
            -84.65098344839829,
            45.70979665270204
          ],
          [
            -84.58176099815155,
            45.492110130738595
          ],
          [
            -84.57995855369379,
            45.48332492433696
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774959_1660122_2018-10-18_104b",
    "properties": {
      "acquired": "2018-10-18T15:30:06.423547Z",
      "anomalous_pixels": 0,
      "black_fill": 0.3,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T02:48:25Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1774959",
      "sun_azimuth": 147.5,
      "sun_elevation": 29.1,
      "updated": "2018-10-19T05:39:56Z",
      "usable_data": 0.7,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660121_2018-10-18_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660121_2018-10-18_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660121_2018-10-18_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.84482025786086,
            45.48867873163698
          ],
          [
            -84.88962387723939,
            45.489491042648986
          ],
          [
            -84.96197914761508,
            45.71578811308727
          ],
          [
            -84.83503555937587,
            45.71348081683456
          ],
          [
            -84.84357571287809,
            45.49054402096962
          ],
          [
            -84.84366154356658,
            45.48867873163698
          ],
          [
            -84.84482025786086,
            45.48867873163698
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774959_1660121_2018-10-18_104b",
    "properties": {
      "acquired": "2018-10-18T15:30:06.900387Z",
      "anomalous_pixels": 0,
      "black_fill": 0.74,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660121",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T02:48:25Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1774959",
      "sun_azimuth": 147.5,
      "sun_elevation": 29,
      "updated": "2018-10-19T05:39:56Z",
      "usable_data": 0.26,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660222_2018-10-18_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660222_2018-10-18_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660222_2018-10-18_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.64780871577456,
            45.70070623500668
          ],
          [
            -84.84822337333951,
            45.704812296694236
          ],
          [
            -84.83955447380457,
            45.929644023421574
          ],
          [
            -84.71866194910213,
            45.92716646887809
          ],
          [
            -84.64780871577456,
            45.70070623500668
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774959_1660222_2018-10-18_104b",
    "properties": {
      "acquired": "2018-10-18T15:30:09.761165Z",
      "anomalous_pixels": 0,
      "black_fill": 0.53,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T02:48:24Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1774959",
      "sun_azimuth": 147.5,
      "sun_elevation": 28.9,
      "updated": "2018-10-19T05:39:55Z",
      "usable_data": 0.47,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660221_2018-10-18_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660221_2018-10-18_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660221_2018-10-18_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83634336104282,
            45.704542555913655
          ],
          [
            -84.95916707623573,
            45.7067303447979
          ],
          [
            -85.03074987041525,
            45.93298704541696
          ],
          [
            -84.82664449324633,
            45.92937536955681
          ],
          [
            -84.83531339278126,
            45.70586123343724
          ],
          [
            -84.83634336104282,
            45.704542555913655
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774959_1660221_2018-10-18_104b",
    "properties": {
      "acquired": "2018-10-18T15:30:10.237742Z",
      "anomalous_pixels": 0,
      "black_fill": 0.51,
      "cloud_cover": 0.003,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T02:48:24Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1774959",
      "sun_azimuth": 147.5,
      "sun_elevation": 28.8,
      "updated": "2018-10-19T05:39:55Z",
      "usable_data": 0.48,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660322_2018-10-18_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660322_2018-10-18_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660322_2018-10-18_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.71607962227934,
            45.91810636524493
          ],
          [
            -84.8398903903896,
            45.92067388714483
          ],
          [
            -84.83109274482196,
            46.145496481555604
          ],
          [
            -84.78714743232807,
            46.144604483903265
          ],
          [
            -84.74805155373242,
            46.02342633904086
          ],
          [
            -84.71607962227934,
            45.91810636524493
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774959_1660322_2018-10-18_104b",
    "properties": {
      "acquired": "2018-10-18T15:30:13.09852Z",
      "anomalous_pixels": 0,
      "black_fill": 0.75,
      "cloud_cover": 0,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T02:48:23Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1774959",
      "sun_azimuth": 147.5,
      "sun_elevation": 28.7,
      "updated": "2018-10-19T05:39:54Z",
      "usable_data": 0.25,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660321_2018-10-18_104b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660321_2018-10-18_104b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1774959_1660321_2018-10-18_104b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8283864939852,
            45.92040775995348
          ],
          [
            -85.0278140986328,
            45.92393046239267
          ],
          [
            -85.10154266002392,
            46.15025610903132
          ],
          [
            -84.81817264205792,
            46.14526116792308
          ],
          [
            -84.82692737228132,
            45.92139294502948
          ],
          [
            -84.82701320296977,
            45.92040775995348
          ],
          [
            -84.8283864939852,
            45.92040775995348
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1774959_1660321_2018-10-18_104b",
    "properties": {
      "acquired": "2018-10-18T15:30:13.57536Z",
      "anomalous_pixels": 0,
      "black_fill": 0.29,
      "cloud_cover": 0.001,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-19T02:48:23Z",
      "rows": 8000,
      "satellite_id": "104b",
      "strip_id": "1774959",
      "sun_azimuth": 147.5,
      "sun_elevation": 28.6,
      "updated": "2018-10-19T05:39:54Z",
      "usable_data": 0.71,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1773055_1660121_2018-10-17_1054",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1773055_1660121_2018-10-17_1054/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1773055_1660121_2018-10-17_1054/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.8446485964839,
            45.48867873163698
          ],
          [
            -85.11677479426106,
            45.49343208903114
          ],
          [
            -85.15921806970682,
            45.622761650325636
          ],
          [
            -85.15801644006832,
            45.65891698700015
          ],
          [
            -84.87318730039841,
            45.70341150020142
          ],
          [
            -84.83949875517604,
            45.59703365748381
          ],
          [
            -84.84361862822234,
            45.48937070101605
          ],
          [
            -84.8446485964839,
            45.48867873163698
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1773055_1660121_2018-10-17_1054",
    "properties": {
      "acquired": "2018-10-17T15:31:28.804271Z",
      "anomalous_pixels": 0.36,
      "black_fill": 0.25,
      "cloud_cover": 0.358,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660121",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T05:43:20Z",
      "rows": 8000,
      "satellite_id": "1054",
      "strip_id": "1773055",
      "sun_azimuth": 147.4,
      "sun_elevation": 29.4,
      "updated": "2018-10-18T05:43:20Z",
      "usable_data": 0.39,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660222_2018-10-17_1012",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660222_2018-10-17_1012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660222_2018-10-17_1012/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.76385180657876,
            45.886465014102285
          ],
          [
            -84.84067027275461,
            45.89909969376926
          ],
          [
            -84.83955447380457,
            45.929644023421574
          ],
          [
            -84.7495609969494,
            45.927823180861104
          ],
          [
            -84.76385180657876,
            45.886465014102285
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772608_1660222_2018-10-17_1012",
    "properties": {
      "acquired": "2018-10-17T16:05:29.794906Z",
      "anomalous_pixels": 0.04,
      "black_fill": 0.96,
      "cloud_cover": 0.038,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T04:37:44Z",
      "rows": 8000,
      "satellite_id": "1012",
      "strip_id": "1772608",
      "sun_azimuth": 156.8,
      "sun_elevation": 31.9,
      "updated": "2018-10-18T05:29:33Z",
      "usable_data": 0,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660221_2018-10-17_1012",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660221_2018-10-17_1012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660221_2018-10-17_1012/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82797486891754,
            45.89703890511992
          ],
          [
            -85.0494180451563,
            45.93316613066169
          ],
          [
            -85.05019052135249,
            45.933345215328146
          ],
          [
            -84.82664449324633,
            45.92940521908145
          ],
          [
            -84.82797486891754,
            45.89703890511992
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772608_1660221_2018-10-17_1012",
    "properties": {
      "acquired": "2018-10-17T16:05:29.794906Z",
      "anomalous_pixels": 0.05,
      "black_fill": 0.95,
      "cloud_cover": 0.045,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T04:37:44Z",
      "rows": 8000,
      "satellite_id": "1012",
      "strip_id": "1772608",
      "sun_azimuth": 156.8,
      "sun_elevation": 31.9,
      "updated": "2018-10-18T05:29:33Z",
      "usable_data": 0,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660322_2018-10-17_1012",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660322_2018-10-17_1012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660322_2018-10-17_1012/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75268641090952,
            45.918852750138925
          ],
          [
            -84.8398903903896,
            45.92067388714483
          ],
          [
            -84.83276644324704,
            46.102307215723755
          ],
          [
            -84.69792643166907,
            46.08022359557165
          ],
          [
            -84.75268641090952,
            45.918852750138925
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772608_1660322_2018-10-17_1012",
    "properties": {
      "acquired": "2018-10-17T16:05:28.737942Z",
      "anomalous_pixels": 0.18,
      "black_fill": 0.75,
      "cloud_cover": 0.178,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T04:37:43Z",
      "rows": 8000,
      "satellite_id": "1012",
      "strip_id": "1772608",
      "sun_azimuth": 156.8,
      "sun_elevation": 31.8,
      "updated": "2018-10-18T05:29:32Z",
      "usable_data": 0.07,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660321_2018-10-17_1012",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660321_2018-10-17_1012/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772608_1660321_2018-10-17_1012/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82860107070636,
            45.92040775995348
          ],
          [
            -84.98828906659483,
            45.9232438515008
          ],
          [
            -85.09085673931008,
            45.93989923105022
          ],
          [
            -85.02609748486351,
            46.13366402150872
          ],
          [
            -84.81993217117144,
            46.10022678615304
          ],
          [
            -84.82697028762554,
            45.92067644852728
          ],
          [
            -84.82860107070636,
            45.92040775995348
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772608_1660321_2018-10-17_1012",
    "properties": {
      "acquired": "2018-10-17T16:05:28.737942Z",
      "anomalous_pixels": 0.28,
      "black_fill": 0.4,
      "cloud_cover": 0.28,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T04:37:43Z",
      "rows": 8000,
      "satellite_id": "1012",
      "strip_id": "1772608",
      "sun_azimuth": 156.8,
      "sun_elevation": 31.8,
      "updated": "2018-10-18T05:29:33Z",
      "usable_data": 0.32,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660223_2018-10-17_100a",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660223_2018-10-17_100a/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660223_2018-10-17_100a/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.41121728964123,
            45.69558039323035
          ],
          [
            -84.54013498371512,
            45.69857782304301
          ],
          [
            -84.53811796253619,
            45.7447778500701
          ],
          [
            -84.40186174459858,
            45.72192230033933
          ],
          [
            -84.41121728964123,
            45.69558039323035
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772607_1660223_2018-10-17_100a",
    "properties": {
      "acquired": "2018-10-17T16:03:55.118722Z",
      "anomalous_pixels": 0.05,
      "black_fill": 0.94,
      "cloud_cover": 0.051,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T02:28:54Z",
      "rows": 8000,
      "satellite_id": "100a",
      "strip_id": "1772607",
      "sun_azimuth": 156.7,
      "sun_elevation": 32,
      "updated": "2018-10-18T05:28:50Z",
      "usable_data": 0.01,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660222_2018-10-17_100a",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660222_2018-10-17_100a/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660222_2018-10-17_100a/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.5276886672683,
            45.69827842163993
          ],
          [
            -84.75269381707837,
            45.70286420283403
          ],
          [
            -84.72780291742362,
            45.776365141756735
          ],
          [
            -84.52537123867974,
            45.742651784575486
          ],
          [
            -84.5276886672683,
            45.69827842163993
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772607_1660222_2018-10-17_100a",
    "properties": {
      "acquired": "2018-10-17T16:03:55.646943Z",
      "anomalous_pixels": 0.15,
      "black_fill": 0.83,
      "cloud_cover": 0.15,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T02:28:54Z",
      "rows": 8000,
      "satellite_id": "100a",
      "strip_id": "1772607",
      "sun_azimuth": 156.6,
      "sun_elevation": 32.1,
      "updated": "2018-10-18T05:28:51Z",
      "usable_data": 0.02,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660123_2018-10-17_100a",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660123_2018-10-17_100a/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772607_1660123_2018-10-17_100a/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.48427623364138,
            45.48122956142411
          ],
          [
            -84.54959338756298,
            45.48276411974169
          ],
          [
            -84.539808689078,
            45.707469979895485
          ],
          [
            -84.40767234418671,
            45.704532967421244
          ],
          [
            -84.48427623364138,
            45.48122956142411
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772607_1660123_2018-10-17_100a",
    "properties": {
      "acquired": "2018-10-17T16:03:58.288306Z",
      "anomalous_pixels": 0.21,
      "black_fill": 0.71,
      "cloud_cover": 0.207,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-18T01:33:31Z",
      "rows": 8000,
      "satellite_id": "100a",
      "strip_id": "1772607",
      "sun_azimuth": 156.6,
      "sun_elevation": 32.2,
      "updated": "2018-10-18T05:28:37Z",
      "usable_data": 0.08,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660223_2018-10-17_0f3b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660223_2018-10-17_0f3b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660223_2018-10-17_0f3b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.22028692315163,
            45.691203857166094
          ],
          [
            -84.5015970045945,
            45.697678610969916
          ],
          [
            -84.5354572111938,
            45.80622871277906
          ],
          [
            -84.5302644545417,
            45.923374964717375
          ],
          [
            -84.25830991814146,
            45.91710553056352
          ],
          [
            -84.21509416649953,
            45.77756206579766
          ],
          [
            -84.2193427855785,
            45.69183338001722
          ],
          [
            -84.22028692315163,
            45.691203857166094
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772465_1660223_2018-10-17_0f3b",
    "properties": {
      "acquired": "2018-10-17T15:28:45.475026Z",
      "anomalous_pixels": 0.13,
      "black_fill": 0.13,
      "cloud_cover": 0.124,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-17T20:22:05Z",
      "rows": 8000,
      "satellite_id": "0f3b",
      "strip_id": "1772465",
      "sun_azimuth": 147.3,
      "sun_elevation": 29.2,
      "updated": "2018-10-18T05:38:34Z",
      "usable_data": 0.74,
      "view_angle": 0.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660222_2018-10-17_0f3b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660222_2018-10-17_0f3b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660222_2018-10-17_0f3b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52416960904124,
            45.7713663122675
          ],
          [
            -84.5400482864072,
            45.8205269326051
          ],
          [
            -84.572706863368,
            45.924211168741024
          ],
          [
            -84.51738898465253,
            45.92310662221286
          ],
          [
            -84.52416960904124,
            45.7713663122675
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772465_1660222_2018-10-17_0f3b",
    "properties": {
      "acquired": "2018-10-17T15:28:46.427658Z",
      "anomalous_pixels": 0.01,
      "black_fill": 0.95,
      "cloud_cover": 0.011,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-17T20:22:05Z",
      "rows": 8000,
      "satellite_id": "0f3b",
      "strip_id": "1772465",
      "sun_azimuth": 147.3,
      "sun_elevation": 29.2,
      "updated": "2018-10-18T05:38:34Z",
      "usable_data": 0.04,
      "view_angle": 0.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660322_2018-10-17_0f3b",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660322_2018-10-17_0f3b/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1772465_1660322_2018-10-17_0f3b/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.51862612346643,
            45.914105571084825
          ],
          [
            -84.56973829844713,
            45.915180439643635
          ],
          [
            -84.64205065347859,
            46.14163105401009
          ],
          [
            -84.50768271068719,
            46.138895356672315
          ],
          [
            -84.51862612346643,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1772465_1660322_2018-10-17_0f3b",
    "properties": {
      "acquired": "2018-10-17T15:28:49.762391Z",
      "anomalous_pixels": 0.22,
      "black_fill": 0.73,
      "cloud_cover": 0.217,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-17T20:22:04Z",
      "rows": 8000,
      "satellite_id": "0f3b",
      "strip_id": "1772465",
      "sun_azimuth": 147.4,
      "sun_elevation": 29,
      "updated": "2018-10-18T05:38:33Z",
      "usable_data": 0.05,
      "view_angle": 0.3
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660122_2018-10-13_1053",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660122_2018-10-13_1053/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660122_2018-10-13_1053/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.53742944755957,
            45.48245234616462
          ],
          [
            -84.76561033284281,
            45.487115969129576
          ],
          [
            -84.83839475666085,
            45.71360239312933
          ],
          [
            -84.52695810356688,
            45.707279327670065
          ],
          [
            -84.53742944755957,
            45.48245234616462
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765710_1660122_2018-10-13_1053",
    "properties": {
      "acquired": "2018-10-13T15:30:27.525539Z",
      "anomalous_pixels": 0.23,
      "black_fill": 0.2,
      "cloud_cover": 0.225,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T02:37:31Z",
      "rows": 8000,
      "satellite_id": "1053",
      "strip_id": "1765710",
      "sun_azimuth": 146.5,
      "sun_elevation": 30.7,
      "updated": "2018-10-14T05:50:16Z",
      "usable_data": 0.57,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660123_2018-10-13_1053",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660123_2018-10-13_1053/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660123_2018-10-13_1053/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.45427840802299,
            45.48053749203683
          ],
          [
            -84.54959338756298,
            45.48273403076466
          ],
          [
            -84.53972285838954,
            45.70755988600643
          ],
          [
            -84.5247883185967,
            45.70714032291817
          ],
          [
            -84.45427840802299,
            45.48053749203683
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765710_1660123_2018-10-13_1053",
    "properties": {
      "acquired": "2018-10-13T15:30:27.05001Z",
      "anomalous_pixels": 0.01,
      "black_fill": 0.84,
      "cloud_cover": 0.011,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T02:37:30Z",
      "rows": 8000,
      "satellite_id": "1053",
      "strip_id": "1765710",
      "sun_azimuth": 146.5,
      "sun_elevation": 30.8,
      "updated": "2018-10-14T05:50:16Z",
      "usable_data": 0.15,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660221_2018-10-13_1053",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660221_2018-10-13_1053/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660221_2018-10-13_1053/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.83552796950241,
            45.704542555913655
          ],
          [
            -84.89869935621239,
            45.90032417022217
          ],
          [
            -84.90848405469737,
            45.93083797737357
          ],
          [
            -84.82664449324633,
            45.92937536955681
          ],
          [
            -84.83552796950241,
            45.704542555913655
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765710_1660221_2018-10-13_1053",
    "properties": {
      "acquired": "2018-10-13T15:30:31.803467Z",
      "anomalous_pixels": 0.04,
      "black_fill": 0.88,
      "cloud_cover": 0.04,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T02:37:29Z",
      "rows": 8000,
      "satellite_id": "1053",
      "strip_id": "1765710",
      "sun_azimuth": 146.6,
      "sun_elevation": 30.5,
      "updated": "2018-10-14T05:50:14Z",
      "usable_data": 0.08,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660222_2018-10-13_1053",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660222_2018-10-13_1053/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660222_2018-10-13_1053/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.52773158261253,
            45.69827842163993
          ],
          [
            -84.83556334679096,
            45.70454256467023
          ],
          [
            -84.84685008232405,
            45.740435450944396
          ],
          [
            -84.83951155846033,
            45.929644023421574
          ],
          [
            -84.59377829738607,
            45.92465895160921
          ],
          [
            -84.52670161435096,
            45.71329320647358
          ],
          [
            -84.52773158261253,
            45.69827842163993
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765710_1660222_2018-10-13_1053",
    "properties": {
      "acquired": "2018-10-13T15:30:31.3282Z",
      "anomalous_pixels": 0.2,
      "black_fill": 0.16,
      "cloud_cover": 0.194,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T02:37:28Z",
      "rows": 8000,
      "satellite_id": "1053",
      "strip_id": "1765710",
      "sun_azimuth": 146.6,
      "sun_elevation": 30.5,
      "updated": "2018-10-14T05:50:14Z",
      "usable_data": 0.64,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660321_2018-10-13_1053",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660321_2018-10-13_1053/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660321_2018-10-13_1053/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82842940932944,
            45.92040775995348
          ],
          [
            -84.90546245222646,
            45.9218407506447
          ],
          [
            -84.97773189191368,
            46.14808574387789
          ],
          [
            -84.81817264205792,
            46.14523143477376
          ],
          [
            -84.82697028762554,
            45.920795865253545
          ],
          [
            -84.82842940932944,
            45.92040775995348
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765710_1660321_2018-10-13_1053",
    "properties": {
      "acquired": "2018-10-13T15:30:34.655331Z",
      "anomalous_pixels": 0.02,
      "black_fill": 0.65,
      "cloud_cover": 0.021,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T02:37:27Z",
      "rows": 8000,
      "satellite_id": "1053",
      "strip_id": "1765710",
      "sun_azimuth": 146.6,
      "sun_elevation": 30.3,
      "updated": "2018-10-14T05:50:12Z",
      "usable_data": 0.33,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660322_2018-10-13_1053",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660322_2018-10-13_1053/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765710_1660322_2018-10-13_1053/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.59222593882487,
            45.91559843846081
          ],
          [
            -84.8398903903896,
            45.92067388714483
          ],
          [
            -84.8311356601662,
            46.145496481555604
          ],
          [
            -84.66234961130048,
            46.14204734386284
          ],
          [
            -84.59098139384213,
            45.915628295398704
          ],
          [
            -84.59222593882487,
            45.91559843846081
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765710_1660322_2018-10-13_1053",
    "properties": {
      "acquired": "2018-10-13T15:30:34.180064Z",
      "anomalous_pixels": 0.03,
      "black_fill": 0.39,
      "cloud_cover": 0.024,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T02:37:26Z",
      "rows": 8000,
      "satellite_id": "1053",
      "strip_id": "1765710",
      "sun_azimuth": 146.6,
      "sun_elevation": 30.3,
      "updated": "2018-10-14T05:50:12Z",
      "usable_data": 0.58,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660123_2018-10-13_1011",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660123_2018-10-13_1011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660123_2018-10-13_1011/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.54787677379369,
              45.522317219917205
            ],
            [
              -84.54435771556663,
              45.60368200408796
            ],
            [
              -84.54384273143584,
              45.61064721449983
            ],
            [
              -84.51899474712535,
              45.60638412804609
            ],
            [
              -84.54787677379369,
              45.522317219917205
            ]
          ]
        ],
        [
          [
            [
              -84.50019782635158,
              45.664118401782915
            ],
            [
              -84.54139655681462,
              45.67092616303017
            ],
            [
              -84.54045241924149,
              45.692303746754604
            ],
            [
              -84.49303096386478,
              45.684239390677085
            ],
            [
              -84.50019782635158,
              45.664118401782915
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1765126_1660123_2018-10-13_1011",
    "properties": {
      "acquired": "2018-10-13T16:04:02.31208Z",
      "anomalous_pixels": 0.02,
      "black_fill": 0.97,
      "cloud_cover": 0.02,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660123",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T01:02:03Z",
      "rows": 8000,
      "satellite_id": "1011",
      "strip_id": "1765126",
      "sun_azimuth": 155.8,
      "sun_elevation": 33.5,
      "updated": "2018-10-14T05:24:32Z",
      "usable_data": 0.01,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765129_1660322_2018-10-13_1042",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765129_1660322_2018-10-13_1042/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765129_1660322_2018-10-13_1042/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.75740709877508,
            45.93721065718977
          ],
          [
            -84.83873167609532,
            45.95078861311784
          ],
          [
            -84.8311356601662,
            46.145496481555604
          ],
          [
            -84.68668261148021,
            46.14255283445241
          ],
          [
            -84.75740709877508,
            45.93721065718977
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765129_1660322_2018-10-13_1042",
    "properties": {
      "acquired": "2018-10-13T16:05:30.181514Z",
      "anomalous_pixels": 0.05,
      "black_fill": 0.7,
      "cloud_cover": 0.05,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T00:46:16Z",
      "rows": 8000,
      "satellite_id": "1042",
      "strip_id": "1765129",
      "sun_azimuth": 156.1,
      "sun_elevation": 33.1,
      "updated": "2018-10-14T05:52:44Z",
      "usable_data": 0.25,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765129_1660321_2018-10-13_1042",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765129_1660321_2018-10-13_1042/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765129_1660321_2018-10-13_1042/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.82606906539665,
            45.94858311671451
          ],
          [
            -85.08364696147905,
            45.9908789450448
          ],
          [
            -85.03017444256558,
            46.148977685121025
          ],
          [
            -84.81817264205792,
            46.14526116792308
          ],
          [
            -84.82606906539665,
            45.94858311671451
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765129_1660321_2018-10-13_1042",
    "properties": {
      "acquired": "2018-10-13T16:05:30.181514Z",
      "anomalous_pixels": 0.11,
      "black_fill": 0.44,
      "cloud_cover": 0.111,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-14T00:46:16Z",
      "rows": 8000,
      "satellite_id": "1042",
      "strip_id": "1765129",
      "sun_azimuth": 156.1,
      "sun_elevation": 33.1,
      "updated": "2018-10-14T05:52:44Z",
      "usable_data": 0.44,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660122_2018-10-13_1011",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660122_2018-10-13_1011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660122_2018-10-13_1011/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.56133329429697,
              45.48293377027579
            ],
            [
              -84.85646211658265,
              45.488921138885246
            ],
            [
              -84.85092603717668,
              45.63452766365319
            ],
            [
              -84.84251462970715,
              45.65981853825632
            ],
            [
              -84.53133546867859,
              45.6085648965167
            ],
            [
              -84.53326665916904,
              45.563754621376546
            ],
            [
              -84.56133329429697,
              45.48293377027579
            ]
          ]
        ],
        [
          [
            [
              -84.52880346336887,
              45.66881609466072
            ],
            [
              -84.6679779247143,
              45.69181327240467
            ],
            [
              -84.79247533833225,
              45.712643490829535
            ],
            [
              -84.64450323141922,
              45.70967678265222
            ],
            [
              -84.62085687674721,
              45.70578086608782
            ],
            [
              -84.52768766441885,
              45.690134528452056
            ],
            [
              -84.52880346336887,
              45.66881609466072
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1765126_1660122_2018-10-13_1011",
    "properties": {
      "acquired": "2018-10-13T16:04:02.840562Z",
      "anomalous_pixels": 0.34,
      "black_fill": 0.33,
      "cloud_cover": 0.339,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660122",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-13T22:29:22Z",
      "rows": 8000,
      "satellite_id": "1011",
      "strip_id": "1765126",
      "sun_azimuth": 155.8,
      "sun_elevation": 33.5,
      "updated": "2018-10-14T05:24:29Z",
      "usable_data": 0.33,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660121_2018-10-13_1011",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660121_2018-10-13_1011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660121_2018-10-13_1011/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.84533524199163,
            45.48867873163698
          ],
          [
            -84.89927982969166,
            45.48979189560646
          ],
          [
            -84.8422453372069,
            45.65984681646152
          ],
          [
            -84.83713841124326,
            45.65900697117126
          ],
          [
            -84.83713841124326,
            45.65804713255726
          ],
          [
            -84.84366154356658,
            45.4887689889946
          ],
          [
            -84.84533524199163,
            45.48867873163698
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765126_1660121_2018-10-13_1011",
    "properties": {
      "acquired": "2018-10-13T16:04:03.897527Z",
      "anomalous_pixels": 0.02,
      "black_fill": 0.93,
      "cloud_cover": 0.023,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660121",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5064500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-13T22:29:22Z",
      "rows": 8000,
      "satellite_id": "1011",
      "strip_id": "1765126",
      "sun_azimuth": 155.7,
      "sun_elevation": 33.6,
      "updated": "2018-10-14T05:24:29Z",
      "usable_data": 0.05,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660223_2018-10-13_1011",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660223_2018-10-13_1011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660223_2018-10-13_1011/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.47387369222041,
            45.7416630963586
          ],
          [
            -84.53781755512657,
            45.75247414037655
          ],
          [
            -84.53022153919744,
            45.923374964717375
          ],
          [
            -84.41289098806628,
            45.920658296894835
          ],
          [
            -84.47387369222041,
            45.7416630963586
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765126_1660223_2018-10-13_1011",
    "properties": {
      "acquired": "2018-10-13T16:03:59.669406Z",
      "anomalous_pixels": 0.11,
      "black_fill": 0.79,
      "cloud_cover": 0.109,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660223",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 691500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-13T22:29:16Z",
      "rows": 8000,
      "satellite_id": "1011",
      "strip_id": "1765126",
      "sun_azimuth": 155.9,
      "sun_elevation": 33.3,
      "updated": "2018-10-14T05:24:28Z",
      "usable_data": 0.1,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660222_2018-10-13_1011",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660222_2018-10-13_1011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660222_2018-10-13_1011/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.58365027614724,
              45.69941740893897
            ],
            [
              -84.73157946771605,
              45.702414633072095
            ],
            [
              -84.82320372765204,
              45.71790771920874
            ],
            [
              -84.81642310326335,
              45.737739791469224
            ],
            [
              -84.58365027614724,
              45.69941740893897
            ]
          ]
        ],
        [
          [
            [
              -84.52511374661437,
              45.75022858495155
            ],
            [
              -84.79784075921076,
              45.79539849762152
            ],
            [
              -84.75363795465145,
              45.92791273189276
            ],
            [
              -84.51738898465253,
              45.92307676929879
            ],
            [
              -84.52511374661437,
              45.75022858495155
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1765126_1660222_2018-10-13_1011",
    "properties": {
      "acquired": "2018-10-13T16:03:59.669406Z",
      "anomalous_pixels": 0.4,
      "black_fill": 0.44,
      "cloud_cover": 0.398,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660222",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-13T22:29:16Z",
      "rows": 8000,
      "satellite_id": "1011",
      "strip_id": "1765126",
      "sun_azimuth": 155.9,
      "sun_elevation": 33.3,
      "updated": "2018-10-14T05:24:28Z",
      "usable_data": 0.16,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660322_2018-10-13_1011",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660322_2018-10-13_1011/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1765126_1660322_2018-10-13_1011/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -84.51849737743375,
            45.914105571084825
          ],
          [
            -84.7566346225789,
            45.91894231565152
          ],
          [
            -84.68217650033581,
            46.14246363056796
          ],
          [
            -84.50768271068719,
            46.138895356672315
          ],
          [
            -84.51849737743375,
            45.914105571084825
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1765126_1660322_2018-10-13_1011",
    "properties": {
      "acquired": "2018-10-13T16:03:56.498512Z",
      "anomalous_pixels": 0.14,
      "black_fill": 0.4,
      "cloud_cover": 0.142,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660322",
      "ground_control": true,
      "gsd": 3.9,
      "item_type": "PSOrthoTile",
      "origin_x": 667500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-13T22:29:14Z",
      "rows": 8000,
      "satellite_id": "1011",
      "strip_id": "1765126",
      "sun_azimuth": 156,
      "sun_elevation": 33.2,
      "updated": "2018-10-14T05:24:22Z",
      "usable_data": 0.46,
      "view_angle": 0.1
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1763595_1660221_2018-10-12_0f4d",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1763595_1660221_2018-10-12_0f4d/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1763595_1660221_2018-10-12_0f4d/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            -85.12379033671093,
            45.832608467417316
          ],
          [
            -85.14224393473083,
            45.88939244466785
          ],
          [
            -85.14893872843106,
            45.93507633728983
          ],
          [
            -84.84363896956232,
            45.92970371344441
          ],
          [
            -84.82848985304831,
            45.88246193051249
          ],
          [
            -84.82861859908103,
            45.87881708910393
          ],
          [
            -85.12379033671093,
            45.832608467417316
          ]
        ]
      ],
      "type": "Polygon"
    },
    "id": "1763595_1660221_2018-10-12_0f4d",
    "properties": {
      "acquired": "2018-10-12T15:31:48.709551Z",
      "anomalous_pixels": 0.23,
      "black_fill": 0.69,
      "cloud_cover": 0.232,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660221",
      "ground_control": true,
      "gsd": 3.5,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5088500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-13T03:37:10Z",
      "rows": 8000,
      "satellite_id": "0f4d",
      "strip_id": "1763595",
      "sun_azimuth": 146.4,
      "sun_elevation": 30.8,
      "updated": "2018-10-13T05:28:04Z",
      "usable_data": 0.08,
      "view_angle": 0.2
    },
    "type": "Feature"
  },
  {
    "_links": {
      "_self": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1763595_1660321_2018-10-12_0f4d",
      "assets": "https://api.planet.com/data/v1/item-types/PSOrthoTile/items/1763595_1660321_2018-10-12_0f4d/assets/",
      "thumbnail": "https://tiles.planet.com/data/v1/item-types/PSOrthoTile/items/1763595_1660321_2018-10-12_0f4d/thumb"
    },
    "_permissions": [
      "assets.analytic_xml:download",
      "assets.analytic_dn:download",
      "assets.analytic:download",
      "assets.visual:download",
      "assets.analytic_dn_xml:download",
      "assets.visual_xml:download",
      "assets.udm:download"
    ],
    "geometry": {
      "coordinates": [
        [
          [
            [
              -84.84164733535299,
              45.920646594305566
            ],
            [
              -85.14548797251783,
              45.92602009542832
            ],
            [
              -85.14896411540064,
              45.93482554125114
            ],
            [
              -85.14853496195832,
              45.94661369490642
            ],
            [
              -84.86701030379429,
              45.99922691218518
            ],
            [
              -84.84641093856278,
              45.94019766893422
            ],
            [
              -84.8407461131241,
              45.920736156922544
            ],
            [
              -84.84164733535299,
              45.920646594305566
            ]
          ]
        ],
        [
          [
            [
              -85.14621753336979,
              46.0155614323663
            ],
            [
              -85.14578837992745,
              46.02646829759784
            ],
            [
              -84.8934461558414,
              46.07358743084717
            ],
            [
              -84.8869230235181,
              46.05539384481684
            ],
            [
              -85.14621753336979,
              46.0155614323663
            ]
          ]
        ],
        [
          [
            [
              -85.1437284434043,
              46.08978092985941
            ],
            [
              -85.14166850688113,
              46.150969635046444
            ],
            [
              -84.91207141523823,
              46.146896466404165
            ],
            [
              -84.90546245222646,
              46.12634764208454
            ],
            [
              -85.1437284434043,
              46.08978092985941
            ]
          ]
        ]
      ],
      "type": "MultiPolygon"
    },
    "id": "1763595_1660321_2018-10-12_0f4d",
    "properties": {
      "acquired": "2018-10-12T15:31:50.609047Z",
      "anomalous_pixels": 0.27,
      "black_fill": 0.63,
      "cloud_cover": 0.27,
      "columns": 8000,
      "epsg_code": 32616,
      "grid_cell": "1660321",
      "ground_control": true,
      "gsd": 3.6,
      "item_type": "PSOrthoTile",
      "origin_x": 643500,
      "origin_y": 5112500,
      "pixel_resolution": 3.125,
      "provider": "planetscope",
      "published": "2018-10-13T03:37:09Z",
      "rows": 8000,
      "satellite_id": "0f4d",
      "strip_id": "1763595",
      "sun_azimuth": 146.4,
      "sun_elevation": 30.7,
      "updated": "2018-10-13T05:28:04Z",
      "usable_data": 0.1,
      "view_angle": 0.2
    },
    "type": "Feature"
  }
]

export default features



// WEBPACK FOOTER //
// ./src/config/planetFeatures.js